module.exports = "<div class=\"animated fadeIn\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <form-consultant-user (loading)=\"loading1=$event\"></form-consultant-user>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n      <form-system-admin (loading)=\"loading2=$event\"></form-system-admin>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n<ngx-loading [show]=\"loading1 || loading2\" [config]=\"{ fullScreenBackdrop:true }\"></ngx-loading>"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/setting/user.component.html
// module id = ../../../../../src/app/views/setting/user.component.html
// module chunks = main